// /convite/:token — pública: quem recebeu o link vê a empresa e cria a conta (e-mail do convite, não editável).
import { useEffect, useState, type FormEvent } from 'react';
import { useNavigate, useParams } from 'react-router';
import { api } from '../api';
import { useMe } from '../me';
import { Wordmark } from '../components/Brand';
import '../styles/company.css';

type Preview = { orgName: string; email: string; role: 'admin' | 'member' };

export function Invite() {
  const { token = '' } = useParams<{ token: string }>();
  const [inv, setInv] = useState<Preview | null>(null);
  const [state, setState] = useState<'loading' | 'ok' | 'invalid'>('loading');
  const [name, setName] = useState('');
  const [pass, setPass] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const { refresh } = useMe();
  const nav = useNavigate();

  useEffect(() => {
    api<Preview>(`/api/client/invites/${encodeURIComponent(token)}`).then((p) => { setInv(p); setState('ok'); }).catch(() => setState('invalid'));   // inexistente, expirado, revogado e usado: a mesma tela
  }, [token]);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      await api(`/api/client/invites/${encodeURIComponent(token)}/accept`, { method: 'POST', body: JSON.stringify({ name, password: pass }) });
      const me = await refresh();
      nav(me && !me.onboardedAt ? '/boas-vindas' : '/chat', { replace: true });
    } catch (e2) { setErr((e2 as Error).message); }
    finally { setBusy(false); }
  };

  return (
    <div className="invite-page">
      <div className="invite-card">
        <Wordmark size="md" />
        {state === 'loading' && <div className="co-skel" aria-hidden="true"><div className="skel" /><div className="skel" /></div>}
        {state === 'invalid' && <><h1>Convite inválido ou expirado</h1><p className="mute">Peça um novo link a quem administra a empresa.</p><a className="btn" href="/entrar">Ir para o login</a></>}
        {state === 'ok' && inv && (
          <form className="gate-form invite-form" onSubmit={submit}>
            <span className="gate-kicker">Convite</span>
            <h1>Você foi convidado para {inv.orgName}</h1>
            <p className="mute">Crie sua conta para entrar na empresa como {inv.role === 'admin' ? 'administrador' : 'membro'}.</p>
            <p className="org-notice" role="note">Esta conta pertence à empresa {inv.orgName}: o administrador pode ver as conversas feitas nela. Cada leitura fica registrada e você pode consultá-las em Configurações.</p>
            <label className="field"><span>E-mail</span><input value={inv.email} readOnly aria-readonly="true" /></label>
            <label className="field"><span>Nome</span><input value={name} onChange={(e) => setName(e.target.value)} autoComplete="name" placeholder="Como quer ser chamado" required /></label>
            <label className="field"><span>Senha <em>· mínimo 8 caracteres</em></span><input type="password" value={pass} onChange={(e) => setPass(e.target.value)} autoComplete="new-password" required minLength={8} placeholder="••••••••" /></label>
            <button type="submit" className="btn primary" disabled={busy}>{busy ? 'Aguarde…' : 'Aceitar convite'}</button>
            <div className="co-err" role="alert">{err}</div>
          </form>
        )}
      </div>
    </div>
  );
}
